import { createContext, useContext } from "react";

import type { CarouselInternals } from "../types";

const CarouselContext = createContext<CarouselInternals | null>(null);
const useCarouselContext = (): CarouselInternals =>
  useContext(CarouselContext) as CarouselInternals;

export { CarouselContext, useCarouselContext };
